export function AuthServerError({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div role="alert" aria-live="assertive" className="rounded-3xl border-2 border-red-400/30 bg-red-400/5 px-5 py-3 element-enter">
      <p className="text-red-400 text-sm">{message}</p>
    </div>
  );
}
